import React from 'react';
import PropTypes from 'prop-types';

function DialogFooter({ children }) {
  return <div className="ws-my-dialog-footer">{children}</div>;
}

DialogFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DialogFooter;
